/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : TopBarNew.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
// src/components/report-designer/TopToolbar.jsx
import React from "react";
import Box from "@mui/material/Box";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import { FormGroup } from "@mui/material";
import AddButtonV2 from "../../../components/customComponentsV2/common/button/AddButtonV2";
import CustomFormTextFieldV2 from "../../../components/customComponentsV2/common/textField/CustomFormTextFieldV2";
import CustomSelectV2 from "../../../components/customComponentsV2/common/select/CustomSelectV2";
import { useSelector } from "react-redux";
import CustomButtonV2 from "../../../components/customComponentsV2/common/button/CustomButtonV2";
import { fontSizeDetails } from "../../../config/appTheme";
import CommonInputSwitch from "../../../components/customComponentsV2/common/InputSwitch/CommonInputSwitch";
import { useNavigate } from "react-router-dom";

export default function TopToolbarNew({
  templateName,
  setTemplateName,
  onNewTemplate,
  handleSaveTemplate,
  handleUpdateTemplate,
  onExportJSON,
  onPreview,
  onToggleLeft,
  onToggleRight,
  handleAddPage,
  formType,
  handleCreateDT,
  setFormType,
  templateId,
  handleUpdateDT,
  isUpdateDisabled,
  handleUpdateStatusChange,
  checked,
  formStatus,
}) {
  console.log(templateId, "templateId");
  const navigate = useNavigate();
  const metaDetails = useSelector((state) => state.settingsReducer.metaData);

  console.log(
    metaDetails?.templates?.template_types,
    "metaDetails?.templates?.template_types",
  );
  /* Constant States */
  const FORM_TYPES = {
    EE: metaDetails?.templates?.template_types?.find(
      (data) => data?.key === "EE COMPONENT",
    )?.value,
    SWM: metaDetails?.templates?.template_types?.find(
      (data) => data?.key === "SOFTWARE MODULE",
    )?.value,
    VEHICLE: metaDetails?.templates?.template_types?.find(
      (data) => data?.key === "VEHICLE COMPONENT",
    )?.value,

    VEHICLE_SYSTEM: metaDetails?.templates?.template_types?.find(
      (data) => data?.key === "VEHICLE SYSTEM",   // ← match whatever key your backend uses
    )?.value,

  };

  //dynamic form changes
  function handelOpenDynamicForm() {
    navigate("/dashboard/admin-settings/ddh_repository?form");
  }
  console.log(formType, "formType");
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        flexWrap: "wrap",
        width: "100%",
        overflowX: "auto",
        overflowy: "hidden",
        bgcolor: "#F4F6F8",
        scrollbarWidth: "none", // Firefox
        "&::-webkit-scrollbar": {
          display: "none", // Chrome / Edge / Safari
        },
        gap: 2,
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "flex-end",
          gap: 1,
          justifyContent: "space-between",
          flexWrap: "nowrap",
          whiteSpace: "nowrap",
          bgcolor: "#F4F6F8",
        }}
      >
        {" "}
        <CustomButtonV2
          type="submit"
          size="small"
          startIcon={<ArrowBackIcon />}
          btnName={"Back"}
          handleOnClick={() => handelOpenDynamicForm()}
        />
      </Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "flex-end",
          gap: 1,
          justifyContent: "space-between",
          flexWrap: "nowrap",
          whiteSpace: "nowrap",
          bgcolor: "#F4F6F8",
        }}
      >
        <Box sx={{ width: "300px" }}>
          <CustomSelectV2
            disabled={templateId ? true : false}
            optionsList={[
              { value: FORM_TYPES?.VEHICLE_SYSTEM, label: "Vehicle Systems" },
              { value: FORM_TYPES?.VEHICLE, label: "Vehicle Components" },
              { value: FORM_TYPES?.EE, label: "EE Components" },
              { value: FORM_TYPES?.SWM, label: "Software Modules" },
            ]}
            size="medium"
            selectedValue={formType}
            handleOnChange={(e) =>
              setFormType(e.target.value)
            }
            label={"Select Type"}
            sltFldStyle={{ fontSize: fontSizeDetails.subtitle2.fontSize }}
          />
        </Box>
        <CustomFormTextFieldV2
          required={true}
          disabled={templateId ? true : false}
          size="small"
          label={"Template Name"}
          value={templateName}
          setValue={setTemplateName}
          txtFldStyle={{ width: "300px" }}
        />
      </Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "flex-end",
          gap: 1,
          justifyContent: "space-between",
          flexWrap: "nowrap",
          whiteSpace: "nowrap",
        }}
      >
        <Box sx={{ display: "flex", justifyContent: "space-between", gap: 2 }}>
          <CustomButtonV2
            type="other"
            size="small"
            btnName="Preview"
            handleOnClick={onPreview}
          />
          {!templateId && (
            <CustomButtonV2
              type="cancel"
              size="small"
              btnName="Save as Draft"
              handleOnClick={() => handleCreateDT(2)}
            />
          )}

          {templateId && (
            <CustomButtonV2
              type="submit"
              size="small"
              btnName={"Update"}
              handleOnClick={() => handleUpdateDT(1)}
              disabled={isUpdateDisabled}
            />
          )}
          {templateId && formStatus == "100" && (
            <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
              <FormGroup>
                <CommonInputSwitch
                  checked={checked}
                  onChange={() => handleUpdateStatusChange(templateId)}
                  label="Save From Draft"
                />
              </FormGroup>
            </Box>
          )}
          {!templateId && (
            <CustomButtonV2
              type="submit"
              size="small"
              btnName={"Create"}
              handleOnClick={() => handleSaveTemplate(1)}
            />
          )}
        </Box>
        <AddButtonV2 handleOnClick={handleAddPage} />
        {/* <Button
          variant="outlined"
          onClick={onExportJSON}
          startIcon={<AddBoxIcon />}
        >
          Export
        </Button> */}
      </Box>
    </Box>
  );
}
